export default "__VITE_ASSET__BrR0dsBu__"